<div class="action-menu-container flex flex-column">
  <app-social-menu-header
    (closeEvent)="closeMenu()"
    (backEvent)="backMenu()"
    [headerTitle]="headerTitle()"
    [showBackButton]="subMenus().length > 0"
  ></app-social-menu-header>
  <div class="menu-wrapper">
    <div class="menu-content-wrapper">
      <app-action-menu [user]="user()" [social]="social()"></app-action-menu>
    </div>
    @for (menu of subMenus(); track menu.title) {
      <div class="menu-content-wrapper" [@slideContent]="'enter'">
        @switch (menu.type) {
          @case (subMenuType.CHAT) {
            <app-social-chat></app-social-chat>
          }
          @case (subMenuType.GUESTS) {
            <app-guests-list></app-guests-list>
          }
          @case (subMenuType.AUDIO_SETTINGS) {
            <app-audio-settings [social]="social()"></app-audio-settings>
          }
          @case (subMenuType.PRESENTATION_SETTINGS) {
            <app-presentation-settings></app-presentation-settings>
          }
          @case (subMenuType.MANAGE_PRESENTERS) {
            <app-manage-presenters></app-manage-presenters>
          }
          @case (subMenuType.FILE_LIBRARY) {
            <app-file-library></app-file-library>
          }
        }
      </div>
    }
  </div>
</div>
